// Actualizado: 3 ítems → 5 ítems con anclas de las secciones nuevas

const menus = [
    {
        id: 2,
        tomenu: "#chapters",
        namemenu: "Trayectoria"
    },
    {
        id: 3,
        tomenu: "#labor",
        namemenu: "Mi labor como Regidora"
    },
    {
        id: 4,
        tomenu: "#resultados",
        namemenu: "Resultados"
    },
    {
        id: 5,
        tomenu: "#author",
        // Actualizado: "Sobre mi" → "Sobre mí" (tilde corregida)
        namemenu: "Sobre mí"
    },
];

export default menus;
